import { isEmpty } from 'lodash';
import Env from '@/env';
export default {
    namespaced: true,
    state: {
      guestLandedQueries: {},
      guestLandedTime: '', // this is for checkout, if user dont checkout for certain interval of time clear his her cart
      userAddress: {},
      userAddressModal: false,
      list: [],
      nearby: {
        locations: [],
      },
      selected: {},
      past_selected_location_id: null,
      default: {},
    },
    getters: {
        guestLandedQueries: state => state.guestLandedQueries,
        guestLandedTime: state => state.guestLandedTime,
        userAddress: state => state.userAddress,
        userAddressModal: state => state.userAddressModal,
        list: state => state.list,
        nearby: state => state.nearby,
        selected: state => state.selected,
        past_selected_location_id: state => state.past_selected_location_id,
        is_greenline_pos(state) {
          if( _.isEmpty(state.selected)){
            return false;
          }
          if(state.selected.settings && state.selected.settings.pos_details && state.selected.settings.pos_details.provider_name){
            if(state.selected.settings.pos_details.provider_name == 'greenline_pos'){
              return true;
            }
            return false;
          }
          return false;
        },

        is_tendy_pos(state) {
          if( _.isEmpty(state.selected)){
            return false;
          }
          if(state.selected.settings && state.selected.settings.pos_details && state.selected.settings.pos_details.provider_name){
            if(state.selected.settings.pos_details.provider_name == 'tendy_pos'){
              return true;
            }
            return false;
          }
          return false;
        },
        cannabis_limit (state) {
          // Get cannabis limit from store, if blak get it from env
          if( _.isEmpty(state.selected) || _.isEmpty(state.selected.settings)){
            return Env.cannabisLimit.toFixed(2);
          }
          return (state.selected.settings && state.selected.settings.cannabis_setting) ? state.selected.settings.cannabis_setting.cannabis_limit.toFixed(2) : Env.cannabisLimit.toFixed(2);
        },
        default (state) {
          // if location selected dset it as default
          if (!_.isEmpty(state.selected)) {
              return state.selected;
          } else if (state.list.length > 0) {
              // else set fist lcoation from list
              return state.list[0];
          } else {
              return {};
          }
        },
        selectedLocationCountryShortcode(state) {
          if( _.isEmpty(state.selected)){
            return 'ca';
          }
          if(state.selected.address && state.selected.address.country){
            return Env.countryShortCodes[state.selected.address.country] ? Env.countryShortCodes[state.selected.address.country] : 'ca';
          } 
          return 'ca';
        },
        /**
         * Get location Vbout data
         */
        selectedLocationVboutStatus (state) {
          // when there is no locaiton always set it to true
          if(_.isEmpty(state.selected) || _.isEmpty(state.selected.settings) ) {
            return false;
          } else {
            return (state.selected.settings.crm_setting && state.selected.settings.crm_setting.api_key && state.selected.settings.crm_setting.site_id) ? true : false;
          }
        },
    },
    mutations: {
        guestLandedQueriesMutate(state, data) {
          state.guestLandedQueries = data;
        },
        guestLandedTimeMutate(state, data) {
          state.guestLandedTime = data;
        },
        userAddressMutate(state, data) {
            state.userAddress = data;
        },
        userAddressModalMutate(state, data) {
            state.userAddressModal = data;
        },
        listMutate(state, data) {
            state.list = data;
        },
        nearbyMutate(state, data) {
            state.nearby = data;
        },
        selectedMutate(state, data) {
          state.selected = data;
        },
        pastSelectedLocationIdMutate(state, data) {
          state.past_selected_location_id = data;
        },
       
    },
    actions: {
        setGuestLandedQueries(context, data) {
          context.commit("guestLandedQueriesMutate", data);
        },
        setGuestLandedTime(context, data) {
          context.commit("guestLandedTimeMutate", data);
        },
        setUserAddress(context, data) {
            context.commit("userAddressMutate", data);
        },
        setUserAddressModal(context, data) {
            context.commit("userAddressModalMutate", data);
        },
        setList(context, data) {
            context.commit("listMutate", data);
        },
        setNearby(context, data) {
            context.commit("nearbyMutate", data);
        },
        setSelected(context, data) {
            context.commit("selectedMutate", data);
        },
        setPastSelectedLocationId(context, data) {
            context.commit("pastSelectedLocationIdMutate", data);
        },
   
    }
}